import axios from 'axios';
import { KEY_ACCESS_TOKEN, KEY_AZURE_TOKEN, KEY_CONFIG_URL, KEY_REFRESH_TOKEN, REFRESH_URL } from '../Constants/constant';
import * as Sentry from '@sentry/react';
import moment from 'moment';
let appConfig;
export let axiosInstance;
const configUrl = KEY_CONFIG_URL;

export const getAxiosInstance = (data) => {
  // if (axiosInstance) {
  //   return axiosInstance;
  // }
  appConfig = data[0]?.config;
  console.log('appConfig.apiBaseUrl', appConfig.apiBaseUrl);
  axiosInstance = axios.create({
    baseURL: `https://spjain-stg-new-api.ken42.com/admission/api/`,
    timeout: 15000,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_AZURE_TOKEN);
    //const token = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers['access-token'] = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      if (resp?.data?.success == false) {
        Sentry.captureException(new Error(`API request failed with status ${resp.status} with error message ${resp.data.errorMessage}`));
        console.error('Response Interceptor Error:', resp.data.errorMessage);
        //  Promise.reject(resp.data.errorMessage);
      }
      return resp;
    },
    async function (error) {
      console.log('ApiService: Interceptor: ', error);

      if (error?.config?.skipRetry) {
        return Promise.reject(error);
      }

      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('API Error Status:', error?.response?.status);
        console.error('API Error Data:', error?.response?.data);
        console.error('API Error Headers:', error?.response?.headers);
        console.error('API Error Message:', error?.response?.data?.[0]?.message);

        // You can handle specific error status codes here
        if (error.response.status === 401) {
          // Redirect to login page or show an error message
          console.error('API Error Message:', error?.response?.data?.[0]?.message);
          console.error('API Error Status:', error?.response?.status);
        } else if (error.response.status === 404) {
          // Handle 404 Not Found error
          console.error('API Error Message:', error?.response?.data?.[0]?.message);
          console.error('API Error Status:', error?.response?.status);
        } else {
          // Handle other errors
          console.error('API Error:', error);
        }
      } else if (error?.request) {
        // The request was made but no response was received
        console.error('API No Response:', error?.request);
      } else {
        // Something happened in setting up the request that triggered an error
        console.error('API Request Setup Error:', error?.message);
      }
      Sentry.captureException(error);
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }
      var config = {
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      };
      // return axios(config).then(function (response) {
      //   localStorage.setItem(KEY_ACCESS_TOKEN, response.data.access_token);
      //   error.response.config.headers[
      //     'Authorization'
      //   ] = `Bearer ${response.data.access_token}`;
      //   return axios(error.response.config);
      // });

      return axios(config).then(async (response) => {
        if (localStorage.refresh_token && (error.response.status === 402 || error.response.status === 502)) {
          const url = REFRESH_URL;
          try {
            const res = await axios.post(
              url,
              {
                refreshToken: localStorage.refresh_token,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.azure_token}`,
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
              }
            );
            // console.log('=====>', res);
            localStorage.setItem(KEY_ACCESS_TOKEN, res?.data?.accessToken?.token);
            localStorage.setItem(KEY_REFRESH_TOKEN, res?.data?.refreshToken?.token);
            // getIntegrationInstance();
            // console.log('9999', response.data);
            localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
            error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token}`;
            error.response.config.headers['access-token'] = res.data.accessToken.token;
            return axios(error.response.config);
          } catch (err) {
            localStorage.clear();

            window.location.reload();
          }
        } else {
          localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
          error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token}`;
          return axios(error.response.config);
        }
      });
    }
  );
};

export const getConfig = async () => {
  // const path = `${window.location.host}`;
  try {
    // const path = 'sp-jain-new-stg-admissionportal.ken42.com';
    // const res = await axios.get(`${configUrl}/${path}`);

    const configJson = process.env.REACT_APP_CONFIG_JSON;
    if (!configJson) {
      console.warn('CONFIG_JSON not found in environment variables');
      return null;
    }

    const config = typeof configJson === 'string' ? JSON.parse(configJson) : configJson;
    return config;
  } catch (error) {
    Sentry.captureException(error);
    console.error(error);
  }
};

export const hdfcPaymentIntegartion = async (data) => {
  try {
    const path = `hdfc/payments/initiate`;
    const response = await axiosInstance.post(`${path}`, data);
    if (!response.status == 200) {
      // Log API error along with response to Sentry
      Sentry.captureException(new Error(`API request failed with status ${response.status}`), {
        extra: { response: await response?.statusText },
      });
    }
    return response;
  } catch (error) {
    Sentry.captureException(error);
    console.error(error);
  }
};

export const getAllPrograms = async (applicantId) => {
  const path = `salesforce?endpoint=services/apexrest/portal/retrieve/forms?applicantid=${applicantId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFormByFormId = async (formId) => {
  const path = `/salesforce?endpoint=services/apexrest/portal/retrieve/form?formid=${formId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicationsByApplicantId = async (applicantid) => {
  const path = `salesforce?endpoint=/services/apexrest/portal/retrieve/applications?applicantid=${applicantid}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getAcademicPrograms = async (applicantid) => {
  const path = `salesforce?endpoint=/services/apexrest/academicApplications`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicationByApplicationId = async (applicationId) => {
  const path = `salesforce?endpoint=/services/apexrest/portal/retrieve/application?applicationid=${applicationId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getContactInfoByContactId = async (contactId) => {
  const path = `salesforce?endpoint=services/apexrest/portal/retrieve/applicant?applicantid=${contactId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createUpdateApplication = async (data) => {
  const EXCLUDED_DATE_KEYS = new Set(['dateOfBirth', 'dateOfExpiry', 'dateOfJoining', 'alumniYear', 'pastBatch', 'annualIncome', 'annualSalary']);
  const ISO_FORMAT_DATE_KEYS = new Set(['dateOfLeaving']);
  const DATE_PARSE_FORMATS = [moment.ISO_8601, 'YYYY-MM-DD', 'YYYY/MM/DD', 'DD-MM-YYYY', 'DD/MM/YYYY', 'MM-DD-YYYY', 'MM/DD/YYYY'];
  const maybeDateKey = (key) => typeof key === 'string' && /date|Date|DOB|Expiry|Passing|Joining|Leaving/i.test(key);
  const isValidDateValue = (val) => {
    if (!val) return false;
    if (val instanceof Date) return true;
    if (typeof val !== 'string') return false;
    return moment(val, DATE_PARSE_FORMATS, true).isValid();
  };

  const transformDates = (obj) => {
    if (obj === null || obj === undefined) return obj;
    if (Array.isArray(obj)) return obj.map((v) => transformDates(v));
    if (typeof obj === 'object') {
      const out = {};
      for (const [k, v] of Object.entries(obj)) {
        if (v && typeof v === 'object') {
          out[k] = transformDates(v);
        } else if (k === 'dateOfExam' && isValidDateValue(v)) {
          out[k] = moment(v).format('YYYY-MM-DD');
        } else if (k === 'yearOfPassing' && isValidDateValue(v)) {
          out[k] = moment(v, DATE_PARSE_FORMATS, true).format('YYYY-MM-DD');
        } else if (k === 'completionYear' && v) {
          if (typeof v === 'string') {
            if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
              out[k] = v;
            } else if (/^\d{4}-\d{2}$/.test(v)) {
              out[k] = `${v}-01`;
            } else if (moment(v, DATE_PARSE_FORMATS, true).isValid()) {
              out[k] = moment(v, DATE_PARSE_FORMATS, true).format('YYYY-MM-DD');
            } else {
              out[k] = v;
            }
          } else {
            out[k] = v;
          }
        } else if (ISO_FORMAT_DATE_KEYS.has(k) && isValidDateValue(v)) {
          out[k] = moment(v, DATE_PARSE_FORMATS, true).format('YYYY-MM-DD');
        } else if (!EXCLUDED_DATE_KEYS.has(k) && (maybeDateKey(k) || isValidDateValue(v))) {
          out[k] = isValidDateValue(v) ? moment(v, DATE_PARSE_FORMATS, true).format('DD/MM/YYYY') : v;
        } else {
          out[k] = v;
        }
      }
      return out;
    }
    return obj;
  };

  const payload = transformDates(data);

  try {
    if (
      payload?.application &&
      payload.application.gradeDocumentFile &&
      typeof payload.application.gradeDocumentFile === 'object'
    ) {
      const fileObj = payload.application.gradeDocumentFile;
      const rawBase64 = fileObj.base64 || '';
      const normalizedBase64 = typeof rawBase64 === 'string' && rawBase64.includes(',')
        ? rawBase64.split(',')[1]
        : rawBase64;

      payload.application.gradeDocument = normalizedBase64 || '';
      payload.application.gradeDocumentName = fileObj.fileName || payload.application.gradeDocumentName || '';
      payload.application.gradeDocumentType = fileObj.mimeType || payload.application.gradeDocumentType || '';

      delete payload.application.gradeDocumentFile;
    }
  } catch (e) {
    console.warn('File normalization warning:', e);
  }
  const path = `salesforce?endpoint=/services/apexrest/portal/save`;
  const res = await axiosInstance.post(`${path}`, payload, {
    timeout: 30000, // 30 seconds timeout
  });
  return res && res.data ? res.data : null;
};

export const deleteApplicationRecords = async (data) => {
  const delData = { data: data };
  const path = `salesforce?endpoint=/services/apexrest/portal/delete`;
  const res = await axiosInstance.delete(`${path}`, delData);
  return res && res.data ? res.data : null;
};

export const getDocuments = async (applicantId) => {
  const path = `salesforce?endpoint=/services/apexrest/portal/retrieve/documentstatus?applicantid=${applicantId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createDocuments = async (data) => {
  const path = `salesforce?endpoint=/services/apexrest/portal/save`;
  const res = await axiosInstance.post(`${path}`, data, {
    timeout: 30000, // 30 seconds timeout
  });
  return res && res.data ? res.data : null;
};

export const getNotifications = async (applicantId) => {
  const path = `salesforce?endpoint=services/apexrest/portal/retrieve/notifications?applicantid=${applicantId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getImportantDates = async () => {
  const path = `salesforce?endpoint=services/apexrest/portal/retrieve/importantdates`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFeeDetails = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portalfee/retrieve/feedetails?applicantid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postFeeCoupon = async (data) => {
  const path = `salesforce?endpoint=/services/apexrest/portalfee/validatecoupon`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postRecordCouponPayment = async ({ applicationId, feeTypeId, couponId, contactId, currencyIsoCode }) => {
  const path = `salesforce?endpoint=/services/apexrest/portalfee/recordcouponpayment`;

  const payload = {
    applicationId,
    feeTypeId,
    couponId,
    contactId,
    currencyIsoCode,
  };

  const res = await axiosInstance.post(path, payload);
  return res && res.data ? res.data : null;
};

export const getOfferLetter = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portalmisc/allofferletters?applicantid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postInitatePayment = async (data) => {
  const path = `payments/flywire/initiate`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getFeeReceipt = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portalfee/retrieve/receipt?transactionid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getQuestionare = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portalmisc/questionarie?contactid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postQuestionare = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portalmisc/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getTransactionDetailsByTransactionId = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portalfee/retrieve/transaction?paymentid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postAppliedCouponCode = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/AppliedCouponCodeAPI`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getRenderingDetails = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portal/retrieve/renderingdetails?applicantid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicantByEmail = async (email) => {
  const path = `salesforce?endpoint=services/apexrest/otp/verifyemail?email=${email}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getDocumentsViaRecordId = async (id) => {
  const path = `salesforce?endpoint=services/apexrest/portalmisc/document?docid=${id}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getOfferletterViaApplicationId = async (id) => {
  const path = `salesforce?endpoint=services/apexrest/portalmisc/offerletter?applicationId=${id}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getInterviewSlotsViaApplicationId = async (id) => {
  const path = `salesforce?endpoint=services/apexrest/interview/retrieve/slottimings?applicationid=${id}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postSaveSlots = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/interview/save/slot`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postSavePreferences = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/portalmisc/save/preferences`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postInterviewSlots = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/interview/save/slot`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const printSummary = async (id) => {
  const path = `salesforce?endpoint=services/apexrest/portal/retrieve/retrieveApplicationForm?applicationId=${id}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postInterviewStudentRequestedSlots = async (data) => {
  const path = `salesforce?endpoint=services/apexrest/interview/save/studentRequestedSlot`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};
